import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import ImgCharm1 from '@/assets/images/lp/entry/img_charm_001.png';
import ImgCharm2 from '@/assets/images/lp/entry/img_charm_002.png';
import ImgCharm3 from '@/assets/images/lp/entry/img_charm_003.png';
import ImgCharm3Webp from '@/assets/images/lp/entry/img_charm_003.png?webp';
import ImgCharm3_2x from '@/assets/images/lp/entry/img_charm_003@2x.png';
import ImgCharm3_2xWebp from '@/assets/images/lp/entry/img_charm_003@2x.png?webp';
import ImgCharm4 from '@/assets/images/lp/entry/img_charm_004.png';
import ImgCharm4Webp from '@/assets/images/lp/entry/img_charm_004.png?webp';
import ImgCharm4_2x from '@/assets/images/lp/entry/img_charm_004@2x.png';
import ImgCharm4_2xWebp from '@/assets/images/lp/entry/img_charm_004@2x.png?webp';
import ImgMerit2 from '@/assets/images/lp/entry/img_merit_002.svg';
import ImgStep1 from '@/assets/images/lp/entry/img_step_1.svg';
import ImgStep2 from '@/assets/images/lp/entry/img_step_2.svg';
import ImgStep3 from '@/assets/images/lp/entry/img_step_3.svg';
import ttlMissionPcStopInv from '@/assets/images/top/ttl_mission_pc_2500.png';
import ttlMissionPcStopInv_2x from '@/assets/images/top/ttl_mission_pc_2500@2x.png';
import ttlMissionPcStopInv_2xWebp from '@/assets/images/top/ttl_mission_pc_2500@2x.png?webp';
import ttlMissionPcStopInv_3x from '@/assets/images/top/ttl_mission_pc_2500@3x.png';
import ttlMissionPcStopInv_3xWebp from '@/assets/images/top/ttl_mission_pc_2500@3x.png?webp';
import ttlMissionPcBonus from '@/assets/images/top/ttl_mission_pc_4000.png';
import ttlMissionPcBonusWebp from '@/assets/images/top/ttl_mission_pc_4000.png?webp';
import ttlMissionPcBonus_2x from '@/assets/images/top/ttl_mission_pc_4000@2x.png';
import ttlMissionPcBonus_2xWebp from '@/assets/images/top/ttl_mission_pc_4000@2x.png?webp';
import ttlMissionPcBonus_3x from '@/assets/images/top/ttl_mission_pc_4000@3x.png';
import ttlMissionPcBonus_3xWebp from '@/assets/images/top/ttl_mission_pc_4000@3x.png?webp';
import ttlMissionSpStopInvWebp from '@/assets/images/top/ttl_mission_sp_2500.png?webp';
import ttlMissionSpStopInv_2xWebp from '@/assets/images/top/ttl_mission_sp_2500@2x.png?webp';
import ttlMissionSpStopInv_3xWebp from '@/assets/images/top/ttl_mission_sp_2500@3x.png?webp';
import ttlMissionSpBonusWebp from '@/assets/images/top/ttl_mission_sp_4000.png?webp';
import ttlMissionSpBonus_2xWebp from '@/assets/images/top/ttl_mission_sp_4000@2x.png?webp';
import ttlMissionSpBonus_3xWebp from '@/assets/images/top/ttl_mission_sp_4000@3x.png?webp';
import Image from '@/components/elements/Image';
import TopBannerList from '@/components/layouts/Top/BannerList';
import MultiraceList from '@/components/layouts/Top/MultiraceList';
import TopNews from '@/components/layouts/Top/News';
import RaceTypeSelector from '@/components/layouts/Top/RaceTypeSelector';
import SingleraceList from '@/components/layouts/Top/SingleraceList';
import { RACE_TYPE_PARAM_KEY } from '@/config/constants/query';
import {
  GoodFormRacer,
  MultiraceProgram,
} from '@/lib/apollo/types/gen/graphql';
import { BannerAreaLabel } from '@/lib/dmm/trackingTag/type';
import { Campaign } from '@/lib/microcms/model';
import { RaceType as RaceTypeParam } from '@/modelTypes';
import { Content, NewsType } from '@/pages/News/types';
import { Banners } from '@/pages/Top';
import { RaceType, RecentRacePrograms } from '@/pages/Top/types';
import { breakPoints } from '@/utility/mediaQuery';

import { HASH_RACE } from '..';
import {
  BannerWrapper,
  BottomBannerList,
  Container,
  ContentsWrapper,
  InformationBox,
  MiddleBannerList,
  NewsWrapper,
  PrimaryBox,
  RaceTypeSelectorWrapper,
  SideBox,
  SlideBannerList,
  TopBannerWrapper,
} from '../style';
import {
  CharmCaution,
  CharmContent,
  CharmDescription,
  CharmHeadLine,
  CharmHeadlineWrapper,
  CharmSection,
  CharmSubHeadline,
  CharmWrapper,
  LinkButton,
  MainVisual,
  MainVisualSection,
  MeritContent,
  MeritDescription,
  MeritHeadLine,
  RegisterWrapper,
  StepAfterAgeConfirm,
  StepArrowIcon,
  StepComplete,
  StepContent,
  StepContentBody,
  StepDescription,
  StepDotIcon,
  StepDotIconWrapper,
  StepHeadLine,
  StepSection,
  StepWrapper,
  Title,
} from './style';

interface TopGuestTemplateProps {
  recentRacePrograms?: RecentRacePrograms;
  multiracePrograms: MultiraceProgram[];
  banners: Banners;
  isBouns: boolean;
  news: Content[];
  blogs: Content[];
  campaigns: Campaign[];
  goodWinStreakRacers: GoodFormRacer[];
  goodWinAverageRacers: GoodFormRacer[];
}

const charms: {
  srcSet: string;
  srcSetWebp?: string;
  alt: string;
  headline: JSX.Element;
  description: JSX.Element;
  subHeadline?: JSX.Element;
  to?: string;
}[] = [
  {
    srcSet: `${ImgCharm1}`,
    alt: '画像の差し替え: お得なチャージバック',
    headline: <>お得なチャージバック</>,
    description: (
      <>
        投票金額に応じて、毎月3回 <span>toreta+ をチャージバック</span>
        。投票すればするほどお得に競輪を楽しめます。
      </>
    ),
    to: '/campaign/chargeback',
  },
  {
    srcSet: `${ImgCharm2}`,
    alt: '画像の差し替え: 魅力的なキャンペーン',
    headline: <>魅力的なキャンペーン</>,
    description: (
      <>
        チャージバックの他にも、お得なキャンペーンが盛りだくさん！
        投票に使えるポイントやグッズをプレゼントしています。
      </>
    ),
    to: '/campaign',
  },
  {
    srcSet: `${ImgCharm3} 1x, ${ImgCharm3_2x} 2x`,
    srcSetWebp: `${ImgCharm3Webp} 1x, ${ImgCharm3_2xWebp} 2x`,
    alt: '選手メモ機能',
    headline: <>選手メモ機能</>,
    subHeadline: <>DMM競輪 オリジナル</>,
    description: (
      <>
        選手一人ひとりに対して自分だけの情報を無制限で記録できます。メモはいつでも参照できます。
      </>
    ),
    to: '/news/info_racermemo',
  },
  {
    srcSet: `${ImgCharm4} 1x, ${ImgCharm4_2x} 2x`,
    srcSetWebp: `${ImgCharm4Webp} 1x, ${ImgCharm4_2xWebp} 2x`,
    alt: '投票成績・収支分析機能',
    headline: <>投票成績・収支分析機能</>,
    description: (
      <>
        収支推移をグラフで見ることができます。また、投票額・払戻額・回収率などの成績をひと目で確認できるので投票成績の分析に役立ちます。
      </>
    ),
  },
];

const steps = [
  {
    srcSet: ImgStep1,
    headline: 'DMM会員登録',
    description: 'まずはDMMアカウントを登録',
  },
  {
    srcSet: ImgStep2,
    headline: 'DMM競輪 利用登録',
    description: 'カンタンな情報入力だけでOK',
  },
  {
    srcSet: ImgStep3,
    headline: '本人確認書類アップ',
    description: '公的書類の確認は最短即日で完了',
  },
];

const RegisterButton: FC<{ isTop?: boolean }> = ({ isTop = false }) => {
  return (
    <RegisterWrapper isTop={isTop}>
      <span>\ 最短10分で登録完了 /</span>
      <LinkButton to="/signup">今すぐ無料登録！</LinkButton>
    </RegisterWrapper>
  );
};

const TopGuestTemplate: FC<TopGuestTemplateProps> = ({
  recentRacePrograms,
  multiracePrograms,
  banners,
  news,
  blogs,
  campaigns,
  isBouns,
  goodWinStreakRacers,
  goodWinAverageRacers,
}) => {
  const { hash, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const paramType = queryParams.get(RACE_TYPE_PARAM_KEY);
  const [raceType, setRaceType] = useState<RaceType>(
    paramType === RaceTypeParam.Multirace
      ? RaceType.Multirace
      : RaceType.Singlerace,
  );
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hash === `#${HASH_RACE}` && ref.current) {
      setTimeout(() => {
        window.scrollTo(0, ref.current!.offsetTop);
      }, 0);
    }
  }, [hash, ref]);

  const missionData = useMemo(
    () => ({
      srcSet: isBouns
        ? `${ttlMissionPcBonus} 1x, ${ttlMissionPcBonus_2x} 2x, ${ttlMissionPcBonus_3x} 3x`
        : `${ttlMissionPcStopInv} 1x, ${ttlMissionPcStopInv_2x} 2x, ${ttlMissionPcStopInv_3x} 3x`,
      mediaSet: isBouns
        ? [
            {
              srcSet: `${ttlMissionPcBonusWebp} 1x, ${ttlMissionPcBonus_2xWebp} 2x, ${ttlMissionPcBonus_3xWebp} 2x`,
              media: `(min-width: ${breakPoints.large}px)`,
              type: 'image/webp',
            },
            {
              srcSet: `${ttlMissionPcBonusWebp} 1x, ${ttlMissionPcBonus_2xWebp} 2x, ${ttlMissionPcBonus_3xWebp} 2x`,
              media: `(min-width: ${breakPoints.medium}px)`,
            },
            {
              srcSet: `${ttlMissionSpBonusWebp} 1x, ${ttlMissionSpBonus_2xWebp} 2x, ${ttlMissionSpBonus_3xWebp} 3x`,
              type: 'image/webp',
            },
          ]
        : [
            {
              srcSet: `${ttlMissionPcStopInv_2xWebp} 1x, ${ttlMissionPcStopInv_2xWebp} 2x, ${ttlMissionPcStopInv_3xWebp} 2x`,
              media: `(min-width: ${breakPoints.large}px)`,
              type: 'image/webp',
            },
            {
              srcSet: `${ttlMissionPcStopInv_2xWebp} 1x, ${ttlMissionPcStopInv_2xWebp} 2x, ${ttlMissionPcStopInv_3xWebp} 2x`,
              media: `(min-width: ${breakPoints.medium}px)`,
            },
            {
              srcSet: `${ttlMissionSpStopInvWebp} 1x, ${ttlMissionSpStopInv_2xWebp} 2x, ${ttlMissionSpStopInv_3xWebp} 3x`,
              type: 'image/webp',
            },
          ],
      alt: `新規登録＋ミッション達成で最大${
        isBouns ? '4,000' : '3,000'
      }円分ポイントもらえる！`,
    }),
    [isBouns],
  );

  return (
    <Container>
      <MainVisualSection>
        <MainVisual>
          <Image
            srcSet={missionData.srcSet}
            mediaSet={missionData.mediaSet}
            width={[303, 303, 485]}
            height={[248, 248, 256]}
            alt={missionData.alt}
          />
          <RegisterButton isTop />
        </MainVisual>
      </MainVisualSection>
      <CharmSection>
        <Title>DMM競輪の魅力</Title>
        <CharmWrapper>
          {charms.map(charm => (
            <CharmContent key={`charm-${charm.alt}`}>
              <Image
                srcSet={charm.srcSet}
                mediaSet={
                  charm.srcSetWebp
                    ? [
                        {
                          srcSet: charm.srcSetWebp,
                          type: 'image/webp',
                        },
                      ]
                    : undefined
                }
                width="100%"
                height={['134px', '134px', '134px', '220px']}
                alt={charm.alt}
              />
              <div>
                <CharmHeadlineWrapper>
                  {charm.subHeadline && (
                    <CharmSubHeadline>{charm.subHeadline}</CharmSubHeadline>
                  )}

                  <CharmHeadLine>{charm.headline}</CharmHeadLine>
                </CharmHeadlineWrapper>
                <CharmDescription>
                  {charm.description}
                  {charm.to && <Link to={charm.to}>詳しくはこちら</Link>}
                </CharmDescription>
              </div>
            </CharmContent>
          ))}
        </CharmWrapper>
        <MeritContent>
          <Image
            srcSet={ImgMerit2}
            width={['100%', '272px', '279px', '279px']}
            height="144px"
            alt="様々な決済手段に対応"
          />
          <div>
            <MeritHeadLine>様々な決済手段に対応</MeritHeadLine>
            <MeritDescription>
              投票に必要な電子マネー「toreta+（トレタプラス）」のチャージは
              スマホ決済（PayPay・メルペイ）・クレジットカード・コンビニ・銀行振込に対応しています。
            </MeritDescription>
          </div>
        </MeritContent>
        <CharmCaution>
          ※画面のデザインは最新のものと異なる場合があります
        </CharmCaution>
      </CharmSection>
      <StepSection>
        <Title>ご登録のながれ</Title>
        <StepWrapper>
          {steps.map((step, i, { length }) => (
            <Fragment key={`step-${i + 1}`}>
              <StepContent>
                <Image
                  srcSet={step.srcSet}
                  width={['72px', '72px', '184px', '184px']}
                  height={['76px', '76px', '195px', '195px']}
                  alt={`STEP${i + 1}`}
                />
                <StepContentBody>
                  <StepHeadLine>{step.headline}</StepHeadLine>
                  <StepDescription>{step.description}</StepDescription>
                </StepContentBody>
              </StepContent>
              {i !== length - 1 && (
                <StepDotIconWrapper>
                  <StepDotIcon />
                </StepDotIconWrapper>
              )}
            </Fragment>
          ))}
        </StepWrapper>
        <StepArrowIcon />
        <StepAfterAgeConfirm>本人確認が承認されると</StepAfterAgeConfirm>
        <StepComplete>
          登録完了
          <br />
          ポイントGET！
        </StepComplete>
        <RegisterButton />
      </StepSection>
      <ContentsWrapper ref={ref}>
        <PrimaryBox>
          <RaceTypeSelectorWrapper>
            <RaceTypeSelector raceType={raceType} setRaceType={setRaceType} />
          </RaceTypeSelectorWrapper>
          <CSSTransition
            in={raceType === RaceType.Singlerace}
            timeout={200}
            unmountOnExit
          >
            <SingleraceList
              recentRacePrograms={recentRacePrograms}
              goodWinStreakRacers={goodWinStreakRacers}
              goodWinAverageRacers={goodWinAverageRacers}
              campaigns={campaigns}
            />
          </CSSTransition>
          <CSSTransition
            in={raceType === RaceType.Multirace}
            timeout={200}
            unmountOnExit
          >
            <MultiraceList multiracePrograms={multiracePrograms} />
          </CSSTransition>
        </PrimaryBox>
        {banners.top.length > 0 && (
          <SideBox>
            <TopBannerWrapper>
              <SlideBannerList>
                <TopBannerList
                  bannerList={banners.top}
                  bannerArea={BannerAreaLabel.TopBanner}
                />
              </SlideBannerList>
            </TopBannerWrapper>
          </SideBox>
        )}
      </ContentsWrapper>
      <InformationBox>
        <NewsWrapper>
          {news.length > 0 && (
            <TopNews type={NewsType.News} contentsList={news} moreFlag />
          )}
          {blogs.length > 0 && (
            <TopNews type={NewsType.Blog} contentsList={blogs} moreFlag />
          )}
        </NewsWrapper>
      </InformationBox>
      {banners.middle.length > 0 && (
        <BannerWrapper>
          <MiddleBannerList>
            <TopBannerList
              bannerList={banners.middle}
              bannerArea={BannerAreaLabel.MiddleBanner}
            />
          </MiddleBannerList>
        </BannerWrapper>
      )}
      {banners.bottom.length > 0 && (
        <BottomBannerList>
          <TopBannerList
            bannerList={banners.bottom}
            bannerArea={BannerAreaLabel.FooterBanner}
          />
        </BottomBannerList>
      )}
    </Container>
  );
};

export default TopGuestTemplate;
